import { replaceWithCdnUrl } from '@/utils/cdnHelper'

const buildCaption = (record) => {
  const caption = record.attributes.caption || ''
  if (!caption) return ''
  return `
    <details class="gallery-caption-container">
      <summary>${caption}</summary>
    </details>
  `
}

export const buildGalleryItem = (record) => {
  if (record.attributes.video) {
    return {
      video: {
        source: [
          {
            src: replaceWithCdnUrl(record.attributes.video_url),
            type: 'video/mp4',
          },
        ],
        // 'metadata', not 'none'. With a poster set (below), lightGallery only
        // builds this <video> when the reader opens the slide, then waits for
        // its loadedmetadata event before revealing and playing it
        // (lg-video.es5.js: loadVideoOnPosterClick). A preload="none" element
        // never fetches metadata on its own, so that event never fires and the
        // slide sits on the loading spinner forever (MEG-4386). 'metadata'
        // fetches just the header. Neighbouring slides are posters, not media
        // elements, so this costs one small request for the slide that was
        // actually opened. Not the boolean false: that renders preload="false",
        // which is invalid and makes the browser download eagerly.
        attributes: { preload: 'metadata', controls: true },
      },
      // A poster changes which branch lightGallery takes. loadContent builds
      // poster markup instead of a <video> (lightgallery.es5.js:1644), and the
      // video plugin only appends a player when hasPoster is false
      // (lg-video.es5.js:223-236). So the four neighbours preload: 2 builds cost
      // an image each rather than a media element, and the reader sees a frame
      // instead of a black rectangle. The slide they opened still autoplays:
      // autoplayFirstVideo routes through loadVideoOnPosterClick.
      poster: replaceWithCdnUrl(record.attributes.video_thumb),
      thumb: replaceWithCdnUrl(record.attributes.video_thumb),
      subHtml: buildCaption(record),
      // Hides the toolbar download icon on video slides; readers download from
      // the player's own controls instead. Without it, setDownloadValue
      // (lightgallery.es5.js) sets the icon's href to downloadUrl || src, and
      // a video item has neither, so attr('href', undefined) acts as a getter
      // and the icon keeps the previous photo's link. false makes it add
      // lg-hide-download to .lg-outer instead; common.scss turns that class
      // into display: none, since lightGallery's own rule only dims the icon.
      downloadUrl: false,
    }
  }
  return {
    src: replaceWithCdnUrl(record.attributes.image),
    thumb: replaceWithCdnUrl(record.attributes.photo),
    subHtml: buildCaption(record),
  }
}
